import { METRIC_LABELS_TO_VALUES } from 'constants/metricLabelsToValues';
import { Tooltip } from 'ui/tooltip';
import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { metricDefinitions, metricsWithDefinitions } from '../assets/metricDefinitions';
import { MetricCard } from './MetricCard';

export const DefinitionWrapper = ({ children: metric }: { children: string }) => {
  const isAnalyticsBotFiltering = useFeatureFlag('AnalyticsBotFiltering');
  if (!metric || !metricsWithDefinitions.has(metric?.toLowerCase())) {
    return <span>{metric}</span>;
  }
  const label = Object.keys(METRIC_LABELS_TO_VALUES(isAnalyticsBotFiltering)).find(
    (key) => key.toLowerCase() === metric.toLowerCase(),
  );
  // @ts-ignore
  const metricName: string = METRIC_LABELS_TO_VALUES(isAnalyticsBotFiltering)[label];
  const metricInfo = metricDefinitions[metricName?.toLowerCase()];
  const definitionExists = Object.keys(metricInfo || {}).length > 1;

  return (
    <Tooltip isEnabled={definitionExists} tooltipContent={<MetricCard metric={metricInfo} />}>
      <span>{metric}</span>
    </Tooltip>
  );
};
